import { QueryClient } from '@tanstack/react-query';

/**
 * Default query configuration for API calls with retry logic
 * Use this for queries that require more resilient retry behavior
 * (e.g., analytics, critical data fetching).
 * For standard queries, the global queryClient default (1 retry) applies.
 * - 5 minutes stale time
 * - 2 retry attempts
 * - Exponential backoff with max delay of 30 seconds
 */
export const DEFAULT_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  retry: 2,
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000)
} as const;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Retry failed queries once (global default)
      // Use DEFAULT_QUERY_CONFIG for queries requiring more resilient retry behavior
      retry: 1
      // Note: React Query doesn't support global error handlers
      // Use useShowErrorSnackbar hook or formatError utility in component error handling
    },
    mutations: {
      // Note: React Query doesn't support global mutation error handlers
      // Use useShowErrorSnackbar hook or formatError utility in component error handling
      // Example: catch (error) { showSnackbar(...formatError(error)...) }
    }
  }
});
